<footer>
    <div [@animateFooter]>
        <div class="footer-right-bar d-none d-md-block">
            <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "footer", "email")' href="mailto:contacto@novabites.cl" target='_blank'>contacto&#64;novabites.cl </a>
        </div>
    </div>
</footer>